export default __webpack_public_path__ + "static/media/trr-event-happyhour.b1516f3c.png";